import React from 'react'
import { Tooltip } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { useEventTimezoneInfoIcon } from './useEventTimezoneInfoIcon'

export const EventTimezoneInfoIcon = ({ eventTimezone }) => {
  const { shouldShow, title } = useEventTimezoneInfoIcon(eventTimezone)

  if (!shouldShow) return null

  return (
    <Tooltip title={title} arrow placement="top">
      <InfoOutlinedIcon
        fontSize="small"
        color="secondary"
        aria-label="Event timezone info"
      />
    </Tooltip>
  )
}
